// GeneralViews
// import DashboardLayout from '@/views/Layout/DashboardLayout.vue';
// import NotFound from '@/views/GeneralViews/NotFoundPage.vue';
import Auth from "@/views/Auth/Main";
import FileAbsent from "@/views/GeneralViews/FileAbsent";

// Auth
const Login = () =>
  import(/* webpackChunkName: "auth" */ "@/views/Auth/Login/component");

const ForgotPassword = () =>
  import(/* webpackChunkName: "auth" */ "@/views/Auth/ForgotPassword");

const MainForgotPassword = () =>
  import(
    /* webpackChunkName: "auth" */ "@/views/Auth/ForgotPassword/Main/component"
  );

const HelpForgotPassword = () =>
  import(
    /* webpackChunkName: "auth" */ "@/views/Auth/ForgotPassword/Help/component"
  );

const EmailForgotPassword = () =>
  import(
    /* webpackChunkName: "auth" */ "@/views/Auth/ForgotPassword/Email/component"
  );

const OtpForgotPassword = () =>
  import(
    /* webpackChunkName: "auth" */ "@/views/Auth/ForgotPassword/Otp/component"
  );

const UpdatePassword = () =>
  import(
    /* webpackChunkName: "auth" */ "@/views/Auth/ForgotPassword/Update/component"
  );

const PresenceAuth = () =>
  import(/* webpackChunkName: "auth" */ "@/views/Auth/Presence/component");

const AbsentAuth = () =>
  import(/* webpackChunkName: "auth" */ "@/views/Auth/Absent/component");

const portalView = () =>
  import(/* webpackChunkName: "auth" */ "@/views/Portal");

const NotFoundPage = () => import("@/views/GeneralViews/NotFoundPage.vue");

const routes = [
  {
    path: "/",
    redirect: "/portal",
  },
  {
    path: "/absent/file/:id",
    name: "FileAbsent",
    component: FileAbsent,
  },
  {
    path: "/auth",
    name: "Auth",
    component: Auth,
    redirect: "/auth/login",
    children: [
      {
        path: "login",
        name: "Login",
        component: Login,
      },
      {
        path: "login/:otp",
        name: "LoginOTP",
        component: Login,
      },
      {
        path: "forgot-password",
        name: "ForgotPassword",
        redirect: { name: "MainForgotPassword" },
        component: ForgotPassword,
        children: [
          {
            path: "main",
            name: "MainForgotPassword",
            component: MainForgotPassword,
          },
          {
            path: "help",
            name: "HelpForgotPassword",
            component: HelpForgotPassword,
          },
          {
            path: "help/:id/otp",
            name: "HelpForgotPasswordOtp",
            component: HelpForgotPassword,
          },
          {
            path: "email",
            name: "EmailForgotPassword",
            component: EmailForgotPassword,
          },
          {
            path: "otp",
            name: "OtpForgotPassword",
            component: OtpForgotPassword,
          },
          {
            path: "update",
            name: "UpdatePassword",
            component: UpdatePassword,
          },
        ],
      },
      {
        path: "presence",
        name: "PresenceAuth",
        component: PresenceAuth,
      },
      {
        path: "absent",
        name: "AbsentAuth",
        component: AbsentAuth,
      },
    ],
  },
  {
    path: "/portal",
    name: "Portal",
    component: portalView,
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "*",
    name: "pageNotFound",
    component: NotFoundPage,
  },
];

export default routes;
